﻿document.addEventListener('DOMContentLoaded', function () {
    function blockBackButton() {
        history.pushState(null, null, location.href);
    }
    blockBackButton();
    window.addEventListener('popstate', function (event) {
        blockBackButton();
    });
});

function StorageManager(dbName = 'storageDB', storeName = 'keyValuePairs') {
    this.dbName = dbName;
    this.storeName = storeName;
    this.db = null;
    this.dbReady = this.init();  // dbReady는 데이터베이스가 준비되면 resolve되는 Promise
}

// IndexedDB 초기화
StorageManager.prototype.init = function () {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.dbName, 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            db.createObjectStore(this.storeName, { keyPath: 'key' });
        };

        request.onsuccess = (event) => {
            this.db = event.target.result;
            resolve(this.db);  // 데이터베이스가 열렸음을 알림
        };

        request.onerror = (event) => {
            console.error('Database error:', event.target.errorCode);
            reject(event.target.errorCode);
        };
    });
};

// 트랜잭션 생성 헬퍼 함수
StorageManager.prototype._getTransaction = function (mode = 'readwrite') {
    // 데이터베이스가 열리기 전에는 트랜잭션을 생성하지 않도록 함
    return this.dbReady.then((db) => {
        if (!db) {
            throw new Error('Database is not initialized');
        }
        const transaction = db.transaction([this.storeName], mode);
        return transaction.objectStore(this.storeName);
    });
};

// 데이터 저장 (만료 시간 설정)
StorageManager.prototype.setItemWithExpiry = function (key, value, ttl = Infinity) {
    return new Promise((resolve, reject) => {
        const expiry = ttl === Infinity ? 'Infinity' : Date.now() + ttl;
        this._getTransaction().then((store) => {
            const item = { key, value, expiry };
            const request = store.put(item);

            request.onsuccess = () => {
                resolve(item);
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 데이터 존재 여부 확인
StorageManager.prototype.hasItem = function (key) {
    return new Promise((resolve, reject) => {
        this._getTransaction('readonly').then((store) => {
            const request = store.get(key);

            request.onsuccess = (event) => {
                const item = event.target.result;
                if (!item) {
                    return resolve(false);
                }

                const expiry = item.expiry === 'Infinity' ? Infinity : item.expiry;
                resolve(expiry >= Date.now());
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 데이터 가져오기
StorageManager.prototype.getItem = function (key) {
    return new Promise((resolve, reject) => {
        this._getTransaction('readonly').then((store) => {
            const request = store.get(key);

            request.onsuccess = (event) => {
                const item = event.target.result;
                if (!item) {
                    return resolve(null);
                }

                const expiry = item.expiry === 'Infinity' ? Infinity : item.expiry;
                if (expiry < Date.now()) {
                    this.removeItem(key).then(() => resolve(null));
                } else {
                    resolve(item.value);
                }
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 데이터 업데이트
StorageManager.prototype.updateItem = function (key, value) {
    return new Promise((resolve, reject) => {
        this.getItem(key).then((oldValue) => {
            if (oldValue === null) {
                return resolve(null);
            }

            this._getTransaction().then((store) => {
                const request = store.get(key);

                request.onsuccess = (event) => {
                    const oldItem = event.target.result;
                    const newItem = {
                        key: key,
                        value: value,
                        expiry: oldItem.expiry
                    };

                    const putRequest = store.put(newItem);

                    putRequest.onsuccess = () => {
                        resolve(newItem.value);
                    };

                    putRequest.onerror = (event) => {
                        reject(event.target.errorCode);
                    };
                };

                request.onerror = (event) => {
                    reject(event.target.errorCode);
                };
            }).catch((err) => {
                reject(err);
            });
        });
    });
};

// 데이터 삭제
StorageManager.prototype.removeItem = function (key) {
    return new Promise((resolve, reject) => {
        this._getTransaction().then((store) => {
            const request = store.delete(key);

            request.onsuccess = () => {
                resolve(true);
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 모든 데이터 삭제
StorageManager.prototype.clear = function () {
    return new Promise((resolve, reject) => {
        this._getTransaction().then((store) => {
            const request = store.clear();

            request.onsuccess = () => {
                resolve(true);
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 모든 유효한 데이터 가져오기
StorageManager.prototype.getAllItems = function () {
    return new Promise((resolve, reject) => {
        this._getTransaction('readonly').then((store) => {
            const request = store.getAll();

            request.onsuccess = (event) => {
                const items = event.target.result;
                const validItems = {};

                items.forEach((item) => {
                    const expiry = item.expiry === 'Infinity' ? Infinity : item.expiry;
                    if (expiry >= Date.now()) {
                        validItems[item.key] = item.value;
                    }
                });

                resolve(validItems);
            };

            request.onerror = (event) => {
                reject(event.target.errorCode);
            };
        }).catch((err) => {
            reject(err);
        });
    });
};

// 사용 예시
const storageManager = new StorageManager();



const inDeflate = (compressed) => {
	var inflator = new Zlib.RawInflate(base64toBinary(compressed));
	var json = BinarytoUtf8(inflator.decompress());
	var scrs = JSON.parse(json);
	return scrs;
};

var base64toBinary = function (base64) {
	var binary_string = atob(base64);
	var len = binary_string.length;
	var bytes = new Uint8Array(len);
	for (var i = 0; i < len; i++) {
		var ascii = binary_string.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes.buffer;
};
function BinarytoUtf8(array) {
	var out, i, len, c;
	var char2, char3;
	out = "";
	len = array.length;
	i = 0;
	while (i < len) {
		c = array[i++];
		switch (c >> 4) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
				out += String.fromCharCode(c);
				break;
			case 12:
			case 13:
				char2 = array[i++];
				out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
				break;
			case 14:
				char2 = array[i++];
				char3 = array[i++];
				out += String.fromCharCode(((c & 0x0F) << 12) |
					((char2 & 0x3F) << 6) |
					((char3 & 0x3F) << 0));
				break;
		}
	}
	return out;
};

const getCookie = (name) => {
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();
		if (cookie.lastIndexOf(name + '=', 0) === 0) {
			return cookie.substring(name.length + 1, cookie.length);
		}
	}
	return null;
};

/**
 * 防抖函数
 *
 * @param param0 防抖参数对象
 * @param param0.delay 防抖延迟时间，单位毫秒
 * @param func 需要防抖的函数
 * @returns 返回一个防抖函数
 */
function debounce(fn, delay) {
    let timer = null
    return function () {
        let context = this
        let args = arguments
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(function () {

            fn.apply(context, args)
        }, delay)
    }
}

export { storageManager, debounce, getCookie, inDeflate };
